// /src/components/PrivateRoute.js
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const PrivateRoute = () => {
  const token = sessionStorage.getItem('accessToken');
  // Falls kein Token vorhanden ist, leite zur Login-Seite weiter
  return token ? <Outlet /> : <Navigate to="/login" />;
};

export default PrivateRoute;

